import script from "./PageFour.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFour.vue?vue&type=script&setup=true&lang=js"

import "./PageFour.vue?vue&type=style&index=0&id=001946aa&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001946aa"]])

export default __exports__